import { CommonModule } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges, inject } from '@angular/core';
import { UpaAsyncService } from '../../../services/upa-async.service';
import { redirectToUrl } from '../utils/navigation.utils';
import {
  LOGIN_URL,
  IFOOD_URL,
  VIEW_ALL_COUPONS,
  SHARE_WITH_FRIENDS_URL,
} from '../utils/urls.constants';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'al-missions',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './missions.component.html',
  styleUrls: ['./missions.component.scss'],
})
export class MissionsComponent implements OnChanges {
  @Input() isEnrolled = false;
  @Input() isLoggedIn = false;
  @Input() isShareWithFriends = false;
  @Input() isTakeExclusiveOffers = false;
  @Input() isClientNotEnrolled = false;
  @Input() source = '';
  @Input() externalShareToastTrigger = 0;

  upaAsyncService = inject(UpaAsyncService);
  http = inject(HttpClient);

  showShareToast = false;
  toastTimeout: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['externalShareToastTrigger'] && !changes['externalShareToastTrigger'].firstChange) {
      this.openShareToast();
    }
  }

  get missions() {
    return [
      {
        title: 'Mantenha-se logado na Decolar',
        subtitle:
          'Acesse sua conta e desbloqueie todos os seus benefícios. Ainda não tem conta? Faça seu cadastro. É grátis e leva menos de 2 minutos.',
        image: 'assets/resources/images/ifood-landing/mission-login.svg',
        status: (isLoggedIn: boolean): string =>
          isLoggedIn ? 'Concluída' : 'Pendente',
        statusClass: (isLoggedIn: boolean): string =>
          isLoggedIn ? 'completed' : 'pending',
      },
      this.isClientNotEnrolled
        ? {
            title: 'Aproveite suas ofertas exclusivas',
            subtitle:
              'Descontos únicos estão esperando por você. Prepare-se para fazer as malas.',
            image: 'assets/resources/images/ifood-landing/mission-discount.svg',
            status: (isTakeExclusiveOffers: boolean): string =>
              isTakeExclusiveOffers ? 'Concluída' : 'Pendente',
            statusClass: (isTakeExclusiveOffers: boolean): string =>
              isTakeExclusiveOffers ? 'completed' : 'pending',
          }
        : {
            title: 'Conecte sua conta iFood',
            subtitle:
              'Conecte suas contas com segurança e comece a ganhar pontos Passaporte a cada pedido que fizer no iFood.',
            image: 'assets/resources/images/ifood-landing/mission-enroll.svg',
            status: (isEnrolled: boolean): string =>
              isEnrolled ? 'Concluída' : 'Pendente',
            statusClass: (isEnrolled: boolean): string =>
              isEnrolled ? 'completed' : 'pending',
          },
      {
        title: 'Compartilhe com amigos',
        subtitle:
          'Esses benefícios são bons demais para serem guardados. Compartilhe esta parceria com seus amigos!',
        image: 'assets/resources/images/ifood-landing/mission-share.svg',
        status: (isShareWithFriends: boolean): string =>
          isShareWithFriends ? 'Concluída' : 'Pendente',
        statusClass: (isShareWithFriends: boolean): string =>
          isShareWithFriends ? 'completed' : 'pending',
      },
    ];
  }

  get missionsCompletedCount(): number {
    let count = 0;
    if (this.isLoggedIn) count++;
    if (this.isEnrolled) count++;
    if (this.isTakeExclusiveOffers) count++;
    if (this.isShareWithFriends) count++;
    return count;
  }

  goToMissionLogin() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'missoes_mantenha-se_logado',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(LOGIN_URL);
  }

  goToMissionEnroll() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'missoes_conecte_sua_conta_iFood',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    redirectToUrl(IFOOD_URL);
  }

  goToMissionTakeTakeExclusiveOffers() {
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'missoes_aproveite_ofertas_exclusivas',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    this.isTakeExclusiveOffers = true;
    // Pegada directa a travel-board
    const params = new URLSearchParams({ mission: 'take_exclusive_offers' });
    this.http
      .post(`/travel-board/ifood-landing/save-mission?${params.toString()}`, {})
      .subscribe();
    redirectToUrl(VIEW_ALL_COUPONS);
  }

  closeShareToast() {
    this.showShareToast = false;
  }

  private openShareToast(): void {
    this.showShareToast = true;
    clearTimeout(this.toastTimeout);
    this.toastTimeout = setTimeout(() => {
      this.showShareToast = false;
    }, 10000);
  }

  goToMissionShareWithFriends() {
    if (navigator && navigator.clipboard) {
      navigator.clipboard.writeText(SHARE_WITH_FRIENDS_URL);
    }
    this.upaAsyncService
      .trackToGeneric(
        'user-action',
        'missoes_compartilhe_com_amigos',
        'click',
        'ifood-landing',
        { source: this.source }
      )
      .subscribe();
    this.isShareWithFriends = true;
    // Pegada directa a travel-board
    const params = new URLSearchParams({ mission: 'share_with_friends' });
    this.http.post(`/travel-board/ifood-landing/save-mission?${params.toString()}`, {}).subscribe();
    this.openShareToast();
  }  

}
